import {
  Component,
  Inject,
  InjectionToken,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { CtaVariantEnum } from '~/component/call-to-action/enums/variant.enum';
import { ComponentVariantEnum } from '~/component/enums/variant';
import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';
import { AlertModalComponent } from '~/component/modal/alert/alert.component';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';
import { RedirectionService } from '~/core/services/redirection/redirection.service';

import { OrganizerSharedLayoutModalConfigInterface } from './interfaces/modal-config.interface';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

export const LEAVE_MODAL_CONFIG = new InjectionToken<
  OrganizerSharedLayoutModalConfigInterface[]
>('Leave Modal Config');

@Component({
  selector: 'app-organizer-shared-layout-funnel',
  templateUrl: './funnel.component.html',
  styleUrls: ['./funnel.component.scss'],
})
export class OrganizerSharedLayoutFunnelComponent implements OnInit, OnDestroy {
  @Input() public hasCloseButton = true;
  @Input() public variant = ComponentVariantEnum.Dark;

  @ViewChild(AlertModalComponent) public leaveModal: AlertModalComponent;

  private readonly subscriptions = new Subscription();

  public buttonVariant = CtaVariantEnum.Link;
  public iconName = VtmnPlayIconTypeEnum.Close;
  public isMobileDevice: boolean;

  constructor(
    @Inject(LEAVE_MODAL_CONFIG)
    public readonly leaveModalConfig: OrganizerSharedLayoutModalConfigInterface,
    private readonly redirectionService: RedirectionService,
    private readonly matchMediaService: MatchMediaService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public get isDarkMode(): boolean {
    return this.variant === ComponentVariantEnum.Dark;
  }

  public get isLightMode(): boolean {
    return this.variant === ComponentVariantEnum.Light;
  }

  public get logoHeight(): number {
    const desktopHeight = 28;
    const mobileHeight = 21;

    return this.isMobileDevice ? mobileHeight : desktopHeight;
  }

  public get logoType(): LogoTypeEnum {
    return this.variant === ComponentVariantEnum.Dark
      ? LogoTypeEnum.OrganizerDark
      : LogoTypeEnum.OrganizerLight;
  }

  public closeModal(): void {
    this.leaveModal.hide();
  }

  public leave(): Promise<boolean> {
    return this.redirectionService.redirect(
      this.leaveModalConfig.redirectRouteName
    );
  }

  public showModal(): void {
    this.leaveModal.show();
  }
}
